import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { HttpClientModule } from '@angular/common/http';
import { AuthService } from '../../core/auth/auth.service';
import { TranslocoModule } from '@ngneat/transloco';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-forgot-password',
    standalone: true,
    imports: [
        RouterLink,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        HttpClientModule,
        TranslocoModule,
        NgIf,
    ],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
    // isToggled
    isToggled = false;

    // Form
    authForm: FormGroup;

    // Show alert
    showAlert: boolean = false;

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private authService: AuthService
    ) {
        this.authForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On submit
     */
    onSubmit(): void {
        // Return if the form is invalid
        if (this.authForm.invalid) {
            this.showAlert = true;
            return;
        }

        // Disable the form
        this.authForm.disable();

        // Hide the alert
        this.showAlert = false;

        this.authService
            .forgotPassword(this.authForm.get('email')?.value)
            .subscribe({
                next: (value) => {
                    // Re-enable the form
                    this.authForm.enable();

                    // Show the alert
                    this.showAlert = true;

                    this.router.navigate(['/authentication/confirm-email']);
                },
                error: (error) => {
                    let errMsg: string = error;
                    // Show the alert
                    this.showAlert = true;
                },
                complete: () => {

                },
            });
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }
}
